import React from 'react';

import Provider from 'pages';
import { setAppPartner } from 'hooks/useAnalytics';
import { ContentContextProvider } from '@qbe/dfc-content';
import cmsProvider from 'resources/cmsProvider';
import { configAnalytics } from '@qbe/qal';

configAnalytics({
  appName: 'cms partners',
  basePagePath: '/au/customer-relations-partner',
  adsEngagementTracking: false,
});

const App = () => {
  setAppPartner();

  return (
    <ContentContextProvider data={cmsProvider}>
      <Provider />
    </ContentContextProvider>
  );
};

export default App;
